module.exports = __webpack_public_path__ + "img/icon-share.4c966196.svg";